import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const MobilePinUnlock = () => {
  const navigate = useNavigate();
  const { loading, token, user, isMobilePinRequired, verifyMobilePin, logout } = useAuth();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!token) {
      navigate('/mobile/login', { replace: true });
      return;
    }
    if (user?.must_change_password) {
      navigate('/mobile/first-login-password', { replace: true });
      return;
    }
    if (!isMobilePinRequired()) {
      navigate('/dashboard', { replace: true });
    }
  }, [loading, token, user, navigate, isMobilePinRequired]);

  const onSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (String(pin || '').trim().length < 4) {
      setError('Saisissez votre PIN.');
      return;
    }
    setSubmitting(true);
    const ok = verifyMobilePin(pin);
    setSubmitting(false);
    if (!ok) {
      setError('PIN incorrect.');
      return;
    }
    navigate('/dashboard', { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#eef0f3] flex items-center justify-center px-5">
      <div className="w-full max-w-sm rounded-3xl border border-slate-200 bg-white p-6 shadow-[0_10px_28px_rgba(15,51,80,0.10)]">
        <h1 className="text-xl font-extrabold text-slate-900 text-center">Déverrouiller Entrea</h1>
        <p className="mt-1 text-sm text-slate-500 text-center">
          Saisissez votre PIN pour continuer
        </p>
        {error && (
          <div className="mt-4 rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
            {error}
          </div>
        )}
        <form onSubmit={onSubmit} className="mt-4 space-y-4">
          <input
            type="password"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={8}
            value={pin}
            onChange={(e) => setPin(String(e.target.value || '').replace(/\D/g, ''))}
            placeholder="PIN"
            className="w-full min-h-[52px] rounded-xl border border-slate-300 px-4 text-center text-lg tracking-[0.22em] focus:outline-none focus:ring-2 focus:ring-entrea-royal/30"
            autoFocus
          />
          <button
            type="submit"
            disabled={submitting}
            className="w-full min-h-[52px] rounded-xl bg-entrea-royal text-white font-semibold text-base shadow-sm active:scale-[0.99] disabled:opacity-60"
          >
            {submitting ? 'Vérification…' : 'Entrer'}
          </button>
        </form>
        <button
          type="button"
          onClick={() => logout()}
          className="mt-4 w-full text-sm text-slate-500 hover:text-slate-700"
        >
          Se déconnecter
        </button>
      </div>
    </div>
  );
};

export default MobilePinUnlock;
